import { createContext, useContext } from 'react'

export const ResultsContext = createContext<any>({})

export const useResultsContext = () => {
  const context = useContext(ResultsContext)
  return context
}
